import {Flow} from "./Flow.js";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {SUBSCRIBE_PLAN_STATE} from "./steps/SubscriptionPlanFlowStep.js";
import {apiUpdateSubscription, SubscriptionApplyPolicy} from "../../../client/state/SubscriptionStore.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {wrapInSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {INLINE_USER_DASHBOARD_URLS} from "../PanelConstants.js";

export class EditSubscriptionFlowHandler extends BaseFlowHandler {
    getFlowPlan() {
        const activeSubscription = iFrameUserDataService.getActiveSubscription();

        return [
            Flow.subscriptionPlan.init({
                subscriptionPlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
                selectedValue: activeSubscription.recurringOffer,
                applyPolicy: SubscriptionApplyPolicy.INSTANTLY,
                discountCode: activeSubscription.getDiscount()?.getCode() || null,
            }),

            Flow.address.init({
                shouldPrompt: () => Flow.subscriptionPlan.selectedValue.shouldCollectAddress(),
                selectedValue: activeSubscription.getShippingAddress(),
            }),

            Flow.paymentMethod.init({
                selectedValue: activeSubscription.getPaymentMethod(),
                savePaymentMethod: true,
                scope: PaymentMethodStore.Scope.PRIVATE,
            }),

            Flow.editSubscriptionConfirmation,
        ]
    }

    async getPayload() {
        const activeSubscription = iFrameUserDataService.getActiveSubscription();

        const payload = {};

        if (Flow.paymentMethod.selectedValue && Flow.paymentMethod.selectedValue !== activeSubscription.getPaymentMethod()) {
            const paymentMethodPayload = await Flow.paymentMethod.getPayload();
            Object.assign(payload, paymentMethodPayload);
        }

        if (Flow.address.selectedValue && Flow.address.selectedValue !== activeSubscription.deliveryAddress) {
            payload.deliveryAddressId = Flow.address.selectedValue.id;
        }

        if (Flow.subscriptionPlan.selectedValue && Flow.subscriptionPlan.selectedValue !== activeSubscription.recurringOfferId) {
            payload.recurringOfferId = Flow.subscriptionPlan.selectedValue.id;
        }

        if (Object.keys(payload).length === 0) {
            // Nothing has changed, no point in calling the endpoint
            return null;
        }

        payload.subscriptionId = activeSubscription.id;
        payload.applyPolicy = Flow.subscriptionPlan.applyPolicy;

        return payload;
    }

    @wrapInSpinner
    async finalize() {
        const payload = await this.getPayload();

        if (!payload) {
            return;
        }

        await apiUpdateSubscription(payload);

        Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess);
    }
}
